import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import useExtratoFiscal from "./hooks/useExtratoFiscal";
import DadosGeraisCard from "./components/DadosGeraisCard";
import ReclamacaoNfpCard from "./components/ReclamacaoNfpCard";
import ObrigacoesAdvertenciasCard from "./components/ObrigacoesAdvertenciasCard";
import ObrigacoesPendenciasCard from "./components/ObrigacoesPendenciasCard";
import ObrigacoesSuspensasCard from "./components/ObrigacoesSuspensasCard";
import DebitosVencidosCard from "./components/DebitosVencidosCard";
import DebitoSuspensoCard from "./components/DebitoSuspensoCard";
import DebitoAcordoSejuscCard from "./components/DebitoAcordoSejuscCard";
import PatCard from "./components/PatCard";
import DebitosVencerCard from "./components/DebitosVencerCard";
import DebitosAcaoCobrancaCard from "./components/DebitosAcaoCobrancaCard";
import DadosCredenciamentoCard from "./components/DadosCredenciamentoCard";
import OcorrenciasFiscaisCard from "./components/OcorrenciasFiscaisCard";
import LiminarLiberacaoCard from "./components/LiminarLiberacaoCard";
import RegimeEspecialCard from "./components/RegimeEspecialCard";
import ParcelamentoCard from "./components/ParcelamentoCard";
import PedidosVirtuaisCard from "./components/PedidosVirtuaisCard";
import ItensDividaAtivaCard from "./components/ItensDividaAtivaCard";
import DebNaoPagosDivAtivaCard from "./components/DebNaoPagosDivAtivaCard";

const ExtratoFiscal = ({ dadosOs }) => {
  const {
    dadosContribuinte,
    listaReclamacao,
    obrigacoesAdvertencias,
    obrigacoesPendencias,
    obrigacoesSuspensas,
    debitosVencidos,
    debitoSuspenso,
    debitoAcordoCejuscFiscal,
    patCriticado,
    debitosVencer,
    debitosAcaoFiscalCobranca,
    dadosCrecenciamento,
    ocorrenciasFiscais,
    liminarLiberacao,
    regimeEspecial,
    patNaoCriticado,
    parcelamento,
    pedidosVirtuais,
    itensDividaAtiva,
    debitosNaoPagosDividaAtiva,
    handleImprimirExtrato,
  } = useExtratoFiscal({ dadosOs });

  return (
    <>
      <Row>
        <Col>
          <h4>Contribuinte: {dadosContribuinte?.nomeContribuinte}</h4>
        </Col>
        <Col className="text-right">
          <Button
            variant="primary"
            className="font-weight-bold text-center tamanho-fonte-botao"
            onClick={() => handleImprimirExtrato(dadosContribuinte?.inscricaoEstadual, dadosContribuinte?.cnpjCnpf)}
          >
            Visualizar Impressão
          </Button>
        </Col>
      </Row>
      <Row>
        <DadosGeraisCard dadosContribuinte={dadosContribuinte} />
      </Row>
      {listaReclamacao?.length > 0 && listaReclamacao[0] !== null && (
        <Row>
          <ReclamacaoNfpCard listaReclamacao={listaReclamacao} />
        </Row>
      )}
      {obrigacoesAdvertencias?.obrigacoes?.length > 0 && obrigacoesAdvertencias?.obrigacoes[0] !== null && (
        <Row>
          <ObrigacoesAdvertenciasCard obrigacoesAdvertencias={obrigacoesAdvertencias} />
        </Row>
      )}
      {obrigacoesPendencias?.obrigacoes?.length > 0 && obrigacoesPendencias?.obrigacoes[0] !== null && (
        <Row>
          <ObrigacoesPendenciasCard obrigacoesPendencias={obrigacoesPendencias} />
        </Row>
      )}
      {obrigacoesSuspensas?.obrigacoes?.length > 0 && obrigacoesSuspensas?.obrigacoes[0] !== null && (
        <Row>
          <ObrigacoesSuspensasCard obrigacoesSuspensas={obrigacoesSuspensas} />
        </Row>
      )}

      <br />
      <h4>Pendências de Obrigações Principais</h4>
      {debitosVencidos?.debitos?.length > 0 && debitosVencidos?.debitos[0] !== null && (
        <Row>
          <DebitosVencidosCard debitosVencidos={debitosVencidos} inscricao={dadosContribuinte.inscricaoEstadual} />
        </Row>
      )}
      {debitoSuspenso?.itensDebitosSuspensosPorSituacao?.length > 0 &&
        debitoSuspenso?.itensDebitosSuspensosPorSituacao[0] !== null && (
          <Row>
            <DebitoSuspensoCard debitoSuspenso={debitoSuspenso} />
          </Row>
        )}
      {debitoAcordoCejuscFiscal?.itensDebitosSuspensosPorSituacao?.length > 0 &&
        debitoAcordoCejuscFiscal?.itensDebitosSuspensosPorSituacao[0] !== null && (
          <Row>
            <DebitoAcordoSejuscCard debitoAcordoCejuscFiscal={debitoAcordoCejuscFiscal} />
          </Row>
        )}
      {patCriticado?.length > 0 && patCriticado[0] !== null && (
        <Row>
          <PatCard processoAdministrativoTributario={patCriticado} />
        </Row>
      )}
      {debitosVencer?.debitos?.length > 0 && debitosVencer?.debitos[0] !== null && (
        <Row>
          <DebitosVencerCard debitosVencer={debitosVencer} inscricao={dadosContribuinte.inscricaoEstadual} />
        </Row>
      )}
      {debitosAcaoFiscalCobranca?.length > 0 && debitosAcaoFiscalCobranca[0] !== null && (
        <Row>
          <DebitosAcaoCobrancaCard debitosAcaoFiscalCobranca={debitosAcaoFiscalCobranca} />
        </Row>
      )}

      <br />
      <h4>Informações Complementares</h4>
      {dadosCrecenciamento?.length > 0 && dadosCrecenciamento[0] !== null && (
        <Row>
          <DadosCredenciamentoCard dadosCredenciamento={dadosCrecenciamento} />
        </Row>
      )}
      {ocorrenciasFiscais?.length > 0 && ocorrenciasFiscais[0] !== null && (
        <Row>
          <OcorrenciasFiscaisCard ocorrenciasFiscais={ocorrenciasFiscais} />
        </Row>
      )}
      {liminarLiberacao?.length > 0 && liminarLiberacao[0] !== null && (
        <Row>
          <LiminarLiberacaoCard liminarLiberacao={liminarLiberacao} />
        </Row>
      )}
      {regimeEspecial?.length > 0 && regimeEspecial[0] !== null && (
        <Row>
          <RegimeEspecialCard regimeEspecial={regimeEspecial} />
        </Row>
      )}
      {patNaoCriticado?.length > 0 && patNaoCriticado[0] !== null && (
        <Row>
          <PatCard processoAdministrativoTributario={patNaoCriticado} />
        </Row>
      )}
      {parcelamento?.length > 0 && parcelamento[0] !== null && (
        <Row>
          <ParcelamentoCard parcelamento={parcelamento} />
        </Row>
      )}
      {pedidosVirtuais?.length > 0 && pedidosVirtuais[0] !== null && (
        <Row>
          <PedidosVirtuaisCard pedidosVirtuais={pedidosVirtuais} />
        </Row>
      )}
      {itensDividaAtiva?.length > 0 && itensDividaAtiva[0] !== null && (
        <Row>
          <ItensDividaAtivaCard itensDividaAtiva={itensDividaAtiva} />
        </Row>
      )}
      {debitosNaoPagosDividaAtiva?.length > 0 && debitosNaoPagosDividaAtiva[0] !== null && (
        <Row>
          <DebNaoPagosDivAtivaCard debitosNaoPagosDividaAtiva={debitosNaoPagosDividaAtiva} />
        </Row>
      )}
    </>
  );
};

export default ExtratoFiscal;
